import { mixed } from 'yup';

export const nilValidator = mixed().default(null).transform(() => null).nullable();

export const undefinedValidator = mixed().default(null).transform(() => undefined).notRequired();
